<template>
  <div class="weight-page">
    <div class="page-header">
      <h1>体重数据</h1>
      <p>监控和管理患者体重变化趋势</p>
    </div>

    <!-- 数据概览 -->
    <!-- <div class="data-overview">
      <div class="overview-card">
        <div class="overview-icon">
          <el-icon><TrendCharts /></el-icon>
        </div>
        <div class="overview-content">
          <div class="overview-number">1,234</div>
          <div class="overview-label">总记录数</div>
        </div>
      </div>
      
      <div class="overview-card">
        <div class="overview-icon">
          <el-icon><User /></el-icon>
        </div>
        <div class="overview-content">
          <div class="overview-number">89</div>
          <div class="overview-label">活跃用户</div>
        </div>
      </div>
      
      <div class="overview-card">
        <div class="overview-icon">
          <el-icon><Calendar /></el-icon>
        </div>
        <div class="overview-content">
          <div class="overview-number">7</div>
          <div class="overview-label">今日新增</div>
        </div>
      </div>
      
      <div class="overview-card">
        <div class="overview-icon">
          <el-icon><Warning /></el-icon>
        </div>
        <div class="overview-content">
          <div class="overview-number">12</div>
          <div class="overview-label">异常数据</div>
        </div>
      </div>
    </div> -->

    <!-- 筛选和操作 -->
    <!-- <div class="filter-section">
      <div class="filter-left">
        <el-autocomplete
          v-model="patientFilter"
          placeholder="请输入患者姓名搜索"
          style="width: 200px"
          clearable
          :fetch-suggestions="queryPatientSuggestions"
          :trigger-on-focus="false"
          :debounce="300"
          @select="handlePatientSelect"
          @keyup.enter="handleSearch"
        >
          <template #prefix>
            <el-icon><Search /></el-icon>
          </template>
        </el-autocomplete>
        <el-input
          v-model="phoneFilter"
          placeholder="请输入手机号搜索"
          style="width: 200px"
          clearable
          @keyup.enter="handleSearch"
        >
          <template #prefix>
            <el-icon><Phone /></el-icon>
          </template>
        </el-input>
        <el-button type="primary" @click="handleSearch" :loading="loading">
          <el-icon><Search /></el-icon>
          搜索
        </el-button>
        <el-button @click="handleReset">
          <el-icon><Refresh /></el-icon>
          重置
        </el-button>
        
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width: 300px"
        />
        
        <el-select v-model="weightRange" placeholder="体重范围" clearable style="width: 150px">
          <el-option label="正常范围" value="normal" />
          <el-option label="偏轻" value="light" />
          <el-option label="偏重" value="heavy" />
          <el-option label="肥胖" value="obese" />
        </el-select>
      </div>
      
      <div class="filter-right">
        <el-button type="primary" @click="exportData">
          <el-icon><Download /></el-icon>
          导出数据
        </el-button>
        <el-button @click="addWeightRecord">
          <el-icon><Plus /></el-icon>
          新增记录
        </el-button>
      </div>
    </div> -->

  <!-- 未搜索患者时的提示 -->
  <div v-if="!patientFilter && !phoneFilter && weightList.length === 0" class="no-patient-tip">
      <div class="tip-content">
        <el-icon size="64" color="#909399"><Search /></el-icon>
        <h3>请输入患者姓名或手机号搜索</h3>
        <p>输入患者姓名或手机号后点击搜索按钮查看体重数据和变化趋势</p>
      </div>
    </div>

  <!-- 体重趋势图 -->
  <div class="chart-section" v-if="patientFilter || phoneFilter">
      <div class="chart-header">
        <h3>近30日体重变化趋势</h3>
        <div class="chart-controls">
          <el-radio-group v-model="chartType" size="small">
            <el-radio-button label="line">折线图</el-radio-button>
            <!-- <el-radio-button label="bar">柱状图</el-radio-button> -->
          </el-radio-group>
          <el-select v-model="timeUnit" size="small" style="width: 100px">
            <el-option label="日" value="day" />
            <el-option label="周" value="week" />
            <!-- <el-option label="月" value="month" /> -->
          </el-select>
        </div>
      </div>
      <div class="chart-container">
        <v-chart 
          :option="chartOption" 
          style="width: 100%; height: 100%;"
          :loading="loading"
        />
      </div>
    </div>

  <!-- 体重数据表格 -->
  <div class="weight-table" v-if="patientFilter || phoneFilter || weightList.length > 0">
      <div class="table-header">
        <h3>体重记录列表</h3>
        <el-button type="text" @click="refreshData">刷新</el-button>
      </div>
      
      <el-table :data="weightList" style="width: 100%" v-loading="loading" :cell-style="{ textAlign: 'center' }" :header-cell-style="{ textAlign: 'center' }">
        <el-table-column type="selection" width="55" />
        <el-table-column prop="userId" label="患者ID" width="100" />
        <!-- <el-table-column prop="patientName" label="患者姓名" width="120" @click="editPatient()" /> -->
        <el-table-column prop="patientName" label="患者姓名" width="120">
          <template #default="{ row }">
            <el-button type="text" @click="editPatient(row)">{{ row.patientName }}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="dryWeight" label="干体重(kg)" width="100">
          <template #default="scope">
            <span>{{ scope.row.dryWeight }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="weight" label="最后一次体重数据(kg)" width="180">
          <template #default="scope">
            <span :class="getWeightClass(scope.row.weight, scope.row.dryWeight)">
              {{ scope.row.weight }}
            </span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="bmi" label="BMI" width="100">
          <template #default="scope">
            <el-tag :type="getBMIType(scope.row.bmi)">
              {{ scope.row.bmi }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="height" label="身高(cm)" width="100" /> -->
        <el-table-column prop="recordTime" label="最后一次更新时间" width="180" sortable />
        <el-table-column prop="type" label="记录类型" width="120">
          <template #default="scope">
            <el-tag :type="getTypeTagType(scope.row.type)">
              {{ getTypeLabel(scope.row.type) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="240">
          <template #default="scope">
            <el-button type="text" @click="editRecord(scope.row)">修改</el-button>
            <el-button type="text" @click="viewUserWeight(scope.row)">查看体重数据</el-button>
            <el-button type="text" @click="deleteRecord(scope.row)" style="color: #f56c6c;">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页（仅在非最新记录视图下显示） -->
      <div class="pagination-wrapper" v-if="!isNewListView">
        <el-pagination
          v-model:current-page="currentPage"
          v-model:page-size="pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>

    <!-- 新增/编辑记录对话框 -->
    <el-dialog
      v-model="recordDialogVisible"
      :title="isEdit ? '编辑体重记录' : '新增体重记录'"
      width="500px"
    >
    
      <el-form :model="weightForm" label-width="100px">
        <el-form-item label="患者姓名">
          <el-autocomplete 
            v-model="weightForm.patientName"
            placeholder="请输入患者姓名搜索"
            :fetch-suggestions="queryPatientSuggestions"
            :trigger-on-focus="false"
            :debounce="300"
            style="width: 100%"
            :disabled="isEdit"
            @select="handleDialogPatientSelect"
          />
        </el-form-item>
        <el-form-item label="体重(kg)">
          <el-input-number 
            v-model="weightForm.weight" 
            :min="20" 
            :max="200" 
            :precision="1"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="记录类型">
          <el-select v-model="weightForm.type" placeholder="选择记录类型" style="width: 100%">
            <el-option label="自测" :value="0" />
            <el-option label="透析前称重" :value="1" />
            <el-option label="透析后称重" :value="2" />
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="干体重(kg)">
          <el-input-number 
            v-model="weightForm.dryWeight" 
            :min="20" 
            :max="200" 
            :precision="1"
            style="width: 100%"
          />
        </el-form-item> -->
        <!-- <el-form-item label="身高(cm)">
          <el-input-number 
            v-model="weightForm.height" 
            :min="100" 
            :max="250" 
            :precision="1"
            style="width: 100%"
          />
        </el-form-item> -->
        <el-form-item label="记录时间">
          <el-date-picker
            v-model="weightForm.createTime"
            type="datetime"
            placeholder="选择日期时间"
            style="width: 100%"
            :default-time="new Date()"
          />
        </el-form-item>
        <el-form-item label="备注">
          <el-input 
            v-model="weightForm.note" 
            type="textarea" 
            :rows="3"
            placeholder="可选备注信息"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="recordDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="saveRecord">确定</el-button>
        </span>
      </template>
    </el-dialog>
    <!-- 查看患者信息对话框 -->
    <el-dialog
      v-model="patientDialogVisible"
      title="查看患者信息"
      width="600px"
    >
      <el-form :model="patientForm" label-width="100px">
        <el-form-item label="患者姓名" required>
          <el-input v-model="patientForm.name" disabled />
        </el-form-item>
        <el-form-item label="手机号" required>
          <el-input v-model="patientForm.phone" disabled />
        </el-form-item>
        <el-form-item label="干体重(kg)" required>
          <el-input-number v-model="patientForm.dryWeight" :min="0" :max="300" :step="0.1" style="width: 100%" disabled/>
        </el-form-item>
        <el-form-item label="性别" required>
          <el-radio-group v-model="patientForm.gender" disabled>
            <el-radio :label="0">男</el-radio>
            <el-radio :label="1">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="出生日期" required>
          <el-date-picker
            v-model="patientForm.birthday"
            type="date"
            value-format="YYYY-MM-DD"
            style="width: 100%"
            disabled
          />
        </el-form-item>
        <!-- <el-form-item label="身份证号">
          <el-input v-model="patientForm.idCard" placeholder="请输入身份证号" />
        </el-form-item> -->
        <!-- <el-form-item label="地址">
          <el-input v-model="patientForm.address" placeholder="请输入地址" />
        </el-form-item> -->
        <el-form-item label="备注">
          <el-input 
            v-model="patientForm.note" 
            type="textarea" 
            :rows="3"
            disabled
          />
        </el-form-item>
      </el-form>
      <!-- <template #footer>
        <span class="dialog-footer">
          <el-button @click="patientDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="savePatient">确定</el-button>
        </span>
      </template> -->
    </el-dialog>
    <!-- 查看单个用户体重历史弹窗 -->
    <el-dialog
      v-model="userWeightDialogVisible"
      :title="`${selectedUserName} 的体重变化`"
      width="90vw"
      :destroy-on-close="true"
    >
      <div class="chart-container" style="height:400px;">
        <v-chart ref="userChartRef" :option="userWeightChartOption" :loading="loading" style="width:100%;height:100%;" />
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="userWeightDialogVisible = false">关闭</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted, watch, nextTick } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { Search, Phone, Download, Plus, Refresh } from '@element-plus/icons-vue'
import { useRoute } from 'vue-router'
import { patientAPI } from '@/api'
import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { LineChart, BarChart } from 'echarts/charts'
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent
} from 'echarts/components'
import VChart from 'vue-echarts'

// 注册 ECharts 组件
use([
  CanvasRenderer,
  LineChart,
  BarChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent
])

const route = useRoute()
const patientFilter = ref('')
const phoneFilter = ref('')
const dateRange = ref([])
const weightRange = ref('')
const chartType = ref('line')
const timeUnit = ref('day')
const currentPage = ref(1)
const pageSize = ref(10)
const total = ref(100)
const recordDialogVisible = ref(false)
const isEdit = ref(false)
const patientDialogVisible = ref(false)
const isNewListView = ref(false) // 是否显示最新记录视图（无分页）

const weightForm = reactive({
  id: null,
  patientName: '',
  patientId: '', // 新增患者ID字段
  weight: 70,
  dryWeight: 70,
  height: 170,
  type: 0, // 默认选择自测
  createdAt: new Date(), // 默认当前时间
  note: ''
}) 
const patientForm = reactive({
  name: '',
  phone: '',
  dryWeight: undefined,
  gender: 0,
  birthday: '',
  idCard: '',
  address: '',
  note: '' 
})

const weightList = ref([])
const loading = ref(false)

// 弹窗用：查看单个用户体重历史
const userWeightDialogVisible = ref(false)
const selectedUserName = ref('')
const selectedUserId = ref(null)
const userWeightList = ref([])
const userChartRef = ref(null)

// 图表配置
const chartOption = computed(() => {
  if (!weightList.value.length) {
    return {
      title: {
        text: '暂无数据',
        left: 'center',
        top: 'middle',
        textStyle: {
          color: '#999',
          fontSize: 16
        }
      }
    }
  }

console.log('weightList.value',weightList.value);


  // 处理数据：按日期(YYYY-MM-DD)归并并对齐每个系列，避免日期重复与错位
  const sortedData = [...weightList.value].sort((a, b) => new Date(a.recordTime) - new Date(b.recordTime))

  // 用于 x 轴与数据对齐的键（按本地日期 YYYY-MM-DD）
  const toDateKey = (ts) => {
    const d = new Date(ts)
    const yyyy = d.getFullYear()
    const mm = String(d.getMonth() + 1).padStart(2, '0')
    const dd = String(d.getDate()).padStart(2, '0')
    return `${yyyy}-${mm}-${dd}`
  }

  // 维护一个按日期的映射，每天只保留最新一条每种类型的数据（覆盖即可，因为 sortedData 已按时间升序）
  const dateMap = {}
  sortedData.forEach(item => {
    const key = toDateKey(item.recordTime || item.createTime || item.createdAt)
    if (!dateMap[key]) dateMap[key] = { self: null, pre: null, post: null, dry: null }
    // 类型说明：0 自测，1 透析前，2 透析后
    const w = typeof item.weight === 'number' ? item.weight : (item.weight ? Number(item.weight) : null)
    if (item.type === 0) dateMap[key].self = w
    else if (item.type === 1) dateMap[key].pre = w
    else if (item.type === 2) dateMap[key].post = w
    // 干体重取最新非空值（覆盖）
    if (item.dryWeight != null) dateMap[key].dry = item.dryWeight
  })

  // x 轴日期列表（保持顺序）
  const dateKeys = Object.keys(dateMap)
  const dates = dateKeys.map(k => {
    const parts = k.split('-')
    return `${Number(parts[1])}/${Number(parts[2])}`
  })

  // 各系列按日期对齐的数据，缺失用 null 占位
  const selfSeries = dateKeys.map(k => dateMap[k].self == null ? null : dateMap[k].self)
  const preSeries = dateKeys.map(k => dateMap[k].pre == null ? null : dateMap[k].pre)
  const postSeries = dateKeys.map(k => dateMap[k].post == null ? null : dateMap[k].post)
  const drySeries = dateKeys.map(k => dateMap[k].dry == null ? null : dateMap[k].dry)

  // y 轴范围：基于存在的体重值计算
  const allWeights = sortedData.map(i => (i.weight != null ? Number(i.weight) : NaN)).filter(v => !Number.isNaN(v))
  const minWeight = allWeights.length ? Math.min(...allWeights) : 0
  const maxWeight = allWeights.length ? Math.max(...allWeights) : 100

  const option = {
    title: {
      text: `${patientFilter.value} 体重变化趋势`,
      left: 'center',
      textStyle: {
        fontSize: 16,
        fontWeight: 'normal'
      }
    },
    tooltip: {
      trigger: 'axis',
      formatter: function(params) {
        if (!params || !params.length) return ''
        let result = `${params[0].axisValue}<br/>`
        params.forEach(param => {
          const value = param.value
          if (value === null || value === undefined || value === '' || Number.isNaN(value)) return
          result += `${param.marker}${param.seriesName}: ${value}kg<br/>`
        })
        return result
      }
    },
    legend: {
      data: ['自测体重', '透析前体重', '透析后体重', '干体重'],
      top: 30
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      top: '15%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: dates,
      axisLabel: {
        rotate: 45
      }
    },
    yAxis: {
      type: 'value',
      name: '体重(kg)',
      min: minWeight - 2,
      max: maxWeight + 2
    },
    series: [
      {
        name: '自测体重',
        type: chartType.value,
        data: selfSeries,
        connectNulls: false,
        smooth: true,
        itemStyle: { color: '#409EFF' },
        lineStyle: { color: '#409EFF' }
      },
      {
        name: '透析前体重',
        type: chartType.value,
        data: preSeries,
        connectNulls: false,
        smooth: true,
        itemStyle: { color: '#E6A23C' },
        lineStyle: { color: '#E6A23C' }
      },
      {
        name: '透析后体重',
        type: chartType.value,
        data: postSeries,
        connectNulls: false,
        smooth: true,
        itemStyle: { color: '#F56C6C' },
        lineStyle: { color: '#F56C6C' }
      },
      {
        name: '干体重',
        type: chartType.value,
        data: drySeries,
        connectNulls: false,
        smooth: true,
        itemStyle: { color: '#67C23A' },
        lineStyle: { color: '#67C23A' }
      }
    ]
  }

  return option
})



// 获取患者列表
const fetchPatientList = async () => {
  loading.value = true
  try {
    // 构建请求参数
    const params = {
      pageNum: 1,
      pageSize: 10
    }
    
    // 添加筛选条件
    if (patientFilter.value) {
      params.name = patientFilter.value
    }
    if (phoneFilter.value) {
      params.phone = phoneFilter.value
    }
    
    const response = await patientAPI.getPatientList(params)
    if (response.code === 0) {
      const records = response.data?.records || []
      // console.log('records',records[0])
      Object.assign(patientForm, records[0] || {})
    } else {
      ElMessage.error(response.msg || '获取患者列表失败')
    }
  } catch (error) {
    ElMessage.error('获取患者列表失败')
    console.error('获取患者列表错误:', error)
    // 使用模拟数据作为后备
    patientList.value = {
      name: '',
      phone: '',
      dryWeight: undefined,
      gender: 0,
      birthday: '',
      idCard: '',
      address: '',
      note: '' 
    }
  } finally {
    loading.value = false
  }
}



const editPatient = async (row) => {
  // 打开患者信息对话框：优先从后端获取完整患者详情，若失败则回退到表格行数据
  isEdit.value = true
  // 清空/初始化表单，避免残留旧数据
  Object.assign(patientForm, {
    name: '',
    phone: '',
    dryWeight: undefined,
    gender: 0,
    birthday: '',
    idCard: '',
    address: '',
    note: ''
  })

  try {
    // 尝试使用 userId（或 row.userId / row.user_id）请求后台详情
    const userId = row.userId || row.user_id || row.userId === 0 ? row.userId : null
    if (userId) {
      const resp = await patientAPI.getPatientDetail({ userId })
      if (resp && resp.code === 0) {
        const data = resp.data || {}
        // 后端可能返回 records 或 data 结构，做兼容处理
        const record = Array.isArray(data.records) && data.records.length > 0 ? data.records[0] : (data.record || data || {})
        Object.assign(patientForm, {
          name: record.name || record.patientName || row.patientName || '',
          phone: record.phone || record.mobile || row.phone || '',
          dryWeight: record.dryWeight != null ? record.dryWeight : (row.dryWeight || undefined),
          gender: record.gender != null ? record.gender : (row.gender || 0),
          birthday: record.birthday || record.birth || row.birthday || '',
          idCard: record.idCard || record.identity || row.idCard || '',
          address: record.address || row.address || '',
          note: record.note || row.note || ''
        })
        patientDialogVisible.value = true
        return
      }
    }
  } catch (err) {
    console.warn('getPatientDetail failed, fallback to row', err)
  }

  // 回退：直接使用表格行的数据（如果后端不可用或返回不完整）
  Object.assign(patientForm, {
    name: row.patientName || row.name || '',
    phone: row.phone || '',
    dryWeight: row.dryWeight || undefined,
    gender: (row.gender === '男' || row.gender === '男' || row.gender === '男') ? 0 : (row.gender === '女' ? 1 : (row.gender || 0)),
    birthday: row.birthday || '',
    idCard: row.idCard || '',
    address: row.address || '',
    note: row.note || ''
  })

  patientDialogVisible.value = true
}


// 患者自动完成建议查询
const queryPatientSuggestions = async (queryString, cb) => {
  if (!queryString) {
    cb([])
    return
  }
  
  try {
    const response = await patientAPI.getPatientList({
      pageNum: 1,
      pageSize: 20,
      name: queryString // 模糊查询患者姓名
    })
    
    if (response.code === 0) {
      const patients = response.data?.records || []
      const suggestions = patients.map(p => ({
        value: p.name, // 显示名称
        id: p.userId,
        name: p.name,
        dryWeight: p.dryWeight,
        label: `${p.name} (ID: ${p.userId})` // 可选显示更多信息
      }))
      cb(suggestions)
    } else {
      cb([])
    }
  } catch (error) {
    console.error('患者自动完成查询错误:', error)
    cb([])
  }
}

// 处理患者选择（主搜索框）
const handlePatientSelect = (item) => {
  patientFilter.value = item.name // 设置选中的患者姓名
  // 直接触发搜索，不依赖 handleSearch 的条件判断
  currentPage.value = 1 // 重置到第一页
  fetchWeightHistory() // 获取体重历史记录
}

// 处理患者选择（对话框）
const handleDialogPatientSelect = (item) => {
  weightForm.patientId = item.id
  weightForm.patientName = item.name
  weightForm.dryWeight = item.dryWeight || 70
}

// 获取体重历史记录
// 支持两种使用方式：
// 1) fetchWeightHistory() - 根据当前 patientFilter/phoneFilter 查询并填充 weightList
// 2) fetchWeightHistory({ userId, forDialog }) - 根据 userId 查询并填充 userWeightList（用于弹窗）
const fetchWeightHistory = async (opts = {}) => {
  const { userId = null, forDialog = false } = opts

  // 如果既没有筛选又没有 userId，则不查询
  if (!userId && !patientFilter.value && !phoneFilter.value) {
    if (forDialog) userWeightList.value = []
    else {
      weightList.value = []
      total.value = 0
    }
    return
  }

  // 当用于页面主列表时，保持分页视图
  if (!forDialog) {
    isNewListView.value = false
    fetchPatientList()
  }

  loading.value = true
  try {
    const params = {
      pageNum: forDialog ? 1 : currentPage.value,
      pageSize: forDialog ? 1000 : pageSize.value, // 弹窗一次性取足够多的历史
      name: patientFilter.value || undefined,
      phone: phoneFilter.value || undefined,
      startDate: dateRange.value?.[0] ? new Date(dateRange.value[0]).toISOString() : undefined,
      endDate: dateRange.value?.[1] ? new Date(dateRange.value[1]).toISOString() : undefined,
    }
    if (userId) params.userId = userId

    const response = await patientAPI.getWeightHistory(params)

    if (response.code === 0) {
      const records = response.data?.records || []
      const mapped = records.map(r => ({
        id: r.id,
        patientName: r.name || r.patientName,
        weight: r.weight,
        bmi: '',
        height: '',
        recordTime: r.createdAt || r.createTime || r.recordTime || '',
        status: '正常',
        gender: r.gender === 1 || r.gender === '1' ? '男' : (r.gender === 0 || r.gender === '0' ? '女' : '男'),
        dryWeight: r.dryWeight,
        userId: r.userId,
        type: r.type || 0,
      }))

      console.log('fetchWeightHistory mapped records:', mapped)

      if (forDialog) {
        userWeightList.value = Array.isArray(mapped) ? [...mapped] : mapped
      } else {
        weightList.value = Array.isArray(mapped) ? [...mapped] : mapped
        total.value = response.data?.total ?? weightList.value.length
      }

      await nextTick()
    } else {
      ElMessage.error(response.msg || '获取体重历史失败')
    }
  } catch (error) {
    ElMessage.error('获取体重历史失败')
    console.error('获取体重历史错误:', error)
    // 回退数据
    const sample = [
      {
        id: 1,
        patientName: patientFilter.value || selectedUserName.value || '示例患者',
        weight: 75.5,
        bmi: 26.1,
        height: 170,
        recordTime: '2024-01-15 08:30:00',
        status: '正常',
        gender: '男',
        dryWeight: 73.0,
        userId: userId || 10000001,
        type: 0
      }
    ]
    if (forDialog) {
      userWeightList.value = sample
    } else {
      weightList.value = sample
      total.value = weightList.value.length
    }
  } finally {
    loading.value = false
  }
}

// 获取前十条最新体重记录（用于页面初始渲染）
const getWeightNewList = async () => {
  loading.value = true
  try {
    const response = await patientAPI.getWeightNewList({ pageNum: 1, pageSize: 10 })
    if (response.code === 0) {
      const records = response.data?.records || []
      weightList.value = records.map(r => ({
        id: r.id,
        patientName: r.name || r.patientName || '-',
        weight: r.weight,
        bmi: '',
        height: '',
        recordTime: r.createdAt || r.createTime || r.recordTime || '',
        status: '正常',
        gender: r.gender === 1 || r.gender === '1' ? '男' : (r.gender === 0 || r.gender === '0' ? '女' : (r.gender || '男')),
        dryWeight: r.dryWeight,
        userId: r.userId,
        type: r.type || 0,
      }))
      // 新的 latest list 是无分页的视图，只显示最新若干条，因此开启无分页模式
      isNewListView.value = true
      total.value = weightList.value.length
    } else {
      ElMessage.error(response.msg || '获取最新体重记录失败')
    }
  } catch (error) {
    console.error('获取最新体重记录错误:', error)
    // 使用模拟数据作为后备
    weightList.value = [
      {
        id: 1,
        patientName: '示例患者',
        weight: 75.5,
        bmi: 26.1,
        height: 170,
        recordTime: '2024-01-15 08:30:00',
        status: '正常',
        gender: '男',
        dryWeight: 73.0,
        userId: 10000001,
        type: 0
      }
    ]
    isNewListView.value = true
    total.value = weightList.value.length
  } finally {
    loading.value = false
  }
}

const getWeightClass = (weight, dryWeight) => {
  const w = Number(weight)
  const d = Number(dryWeight)
  if (!Number.isFinite(w) || !Number.isFinite(d)) return ''
  if (w > d) return 'weight-above-dry'
  if (w < d) return 'weight-below-dry'
  return ''
}

const getBMIType = (bmi) => {
  if (bmi < 18.5) return 'warning'
  if (bmi >= 18.5 && bmi < 24) return 'success'
  if (bmi >= 24 && bmi < 28) return 'warning'
  return 'danger'
}

const getTypeLabel = (type) => {
  const labels = {
    0: '自测',
    1: '透析前',
    2: '透析后'
  }
  return labels[type] || '未知'
}

const getTypeTagType = (type) => {
  const types = {
    0: 'primary',   // 自测 - 蓝色
    1: 'warning',   // 透析前 - 橙色
    2: 'danger'     // 透析后 - 红色
  }
  return types[type] || 'info'
}

const getStatusType = (status) => {
  const types = {
    '正常': 'success',
    '偏轻': 'warning',
    '偏重': 'warning',
    '肥胖': 'danger'
  }
  return types[status] || 'info'
}

const exportData = () => {
  ElMessage.success('数据导出功能')
}

const addWeightRecord = () => {
  isEdit.value = false
  Object.assign(weightForm, {
    id: null,
    patientName: '',
    patientId: '',
    weight: 70,
    dryWeight: 70,
    height: 170,
    type: 0,
    createdAt: new Date(),
    note: ''
  })
  recordDialogVisible.value = true
}

const editRecord = (row) => {
  isEdit.value = true
  Object.assign(weightForm, {
    id: row.id,
    patientName: row.patientName || row.name || '',
    patientId: row.userId || '',
    weight: row.weight,
    dryWeight: row.dryWeight || row.weight,
    height: row.height,
    type: row.type ?? 0,
    createdAt: row.recordTime,
    createTime: row.recordTime ? new Date(row.recordTime) : new Date(),
    note: row.note || ''
  })
  recordDialogVisible.value = true
}

const viewTrend = (row) => {
  ElMessage.info(`查看${row.patientName}的体重趋势`)
}

// 查看单个用户体重数据（弹窗）
const viewUserWeight = async (row) => {
  selectedUserName.value = row.patientName || row.name || '用户'
  selectedUserId.value = row.userId || row.user_id || null
  userWeightDialogVisible.value = true
  // 请求该用户的历史体重数据（不受页面筛选限制）
  await fetchWeightHistory({ userId: selectedUserId.value, forDialog: true })
  // 等待 DOM 更新并触发图表重绘/重置尺寸，保证占满容器
  await nextTick()
  // 优先使用组件实例的 resize / getEchartsInstance 方法
  try {
    if (userChartRef.value) {
      // vue-echarts 通常提供 getEchartsInstance 或 resize 方法
      const comp = userChartRef.value
      if (typeof comp.resize === 'function') {
        comp.resize()
      } else if (typeof comp.getEchartsInstance === 'function') {
        const inst = comp.getEchartsInstance()
        if (inst && typeof inst.resize === 'function') inst.resize()
      } else {
        // 回退：触发 window resize 事件
        window.dispatchEvent(new Event('resize'))
      }
    } else {
      window.dispatchEvent(new Event('resize'))
    }
  } catch (err) {
    console.warn('chart resize failed, fallback to window resize', err)
    window.dispatchEvent(new Event('resize'))
  }
  // 再次延时调用一次 resize，避免对话框动画导致的测量问题
  setTimeout(() => {
    try {
      if (userChartRef.value) {
        const comp = userChartRef.value
        if (typeof comp.resize === 'function') comp.resize()
        else if (typeof comp.getEchartsInstance === 'function') {
          const inst = comp.getEchartsInstance()
          if (inst && typeof inst.resize === 'function') inst.resize()
        } else window.dispatchEvent(new Event('resize'))
      } else window.dispatchEvent(new Event('resize'))
    } catch (e) {
      // ignore
    }
  }, 80)
}

// 弹窗图表配置
const userWeightChartOption = computed(() => {
  if (!userWeightList.value || !userWeightList.value.length) {
    return {
      title: { text: '暂无数据', left: 'center', top: 'middle', textStyle: { color: '#999', fontSize: 16 } }
    }
  }

  // 按日期归并，确保同一天的数据不会重复显示（采用与主图相同的归并策略）
  const sorted = [...userWeightList.value].sort((a, b) => new Date(a.recordTime) - new Date(b.recordTime))
  const toDateKey = (ts) => {
    const d = new Date(ts)
    const yyyy = d.getFullYear()
    const mm = String(d.getMonth() + 1).padStart(2, '0')
    const dd = String(d.getDate()).padStart(2, '0')
    return `${yyyy}-${mm}-${dd}`
  }

  const dateMap = {}
  sorted.forEach(item => {
    const key = toDateKey(item.recordTime || item.createTime || item.createdAt)
    if (!dateMap[key]) dateMap[key] = { self: null, pre: null, post: null, dry: null }
    const w = typeof item.weight === 'number' ? item.weight : (item.weight ? Number(item.weight) : null)
    if (item.type === 0) dateMap[key].self = w
    else if (item.type === 1) dateMap[key].pre = w
    else if (item.type === 2) dateMap[key].post = w
    if (item.dryWeight != null) dateMap[key].dry = item.dryWeight
  })

  const dateKeys = Object.keys(dateMap)
  const dates = dateKeys.map(k => {
    const parts = k.split('-')
    return `${Number(parts[1])}/${Number(parts[2])}`
  })

  const selfSeries = dateKeys.map(k => dateMap[k].self == null ? null : dateMap[k].self)
  const preSeries = dateKeys.map(k => dateMap[k].pre == null ? null : dateMap[k].pre)
  const postSeries = dateKeys.map(k => dateMap[k].post == null ? null : dateMap[k].post)
  const drySeries = dateKeys.map(k => dateMap[k].dry == null ? null : dateMap[k].dry)

  const allWeights = [...selfSeries, ...preSeries, ...postSeries].filter(v => v != null)
  const minW = allWeights.length ? Math.min(...allWeights) : 0
  const maxW = allWeights.length ? Math.max(...allWeights) : 100

  return {
    title: { text: `${selectedUserName.value} 体重变化`, left: 'center', textStyle: { fontSize: 16 } },
    tooltip: {
      trigger: 'axis',
      formatter: function(params) {
        if (!params || !params.length) return ''
        let result = `${params[0].axisValue}<br/>`
        params.forEach(param => {
          const value = param.value
          if (value === null || value === undefined || value === '' || Number.isNaN(value)) return
          result += `${param.marker}${param.seriesName}: ${value}kg<br/>`
        })
        return result
      }
    },
    legend: { data: ['自测体重', '透析前体重', '透析后体重', '干体重'], top: 30 },
    xAxis: { type: 'category', data: dates, boundaryGap: false, axisLabel: { rotate: 45 } },
    yAxis: { type: 'value', name: '体重(kg)', min: minW - 2, max: maxW + 2 },
    grid: { left: '3%', right: '4%', bottom: '3%', top: '15%', containLabel: true },
    series: [
      { name: '自测体重', type: chartType.value, data: selfSeries, smooth: true, itemStyle: { color: '#409EFF' } },
      { name: '透析前体重', type: chartType.value, data: preSeries, smooth: true, itemStyle: { color: '#E6A23C' } },
      { name: '透析后体重', type: chartType.value, data: postSeries, smooth: true, itemStyle: { color: '#F56C6C' } },
      { name: '干体重', type: chartType.value, data: drySeries, smooth: true, itemStyle: { color: '#67C23A' } }
    ]
  }
})

const deleteRecord = async (row) => {
  ElMessageBox.confirm(
    `确定要删除${row.patientName}的体重记录吗？`,
    '警告',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  ).then(async () => {
    try {
      const response = await patientAPI.deleteWeightHistory({ id: row.id })
      if (response.code === 0) {
        ElMessage.success('删除成功')
        fetchWeightHistory() // 重新获取数据
      } else {
        ElMessage.error(response.msg || '删除失败')
      }
    } catch (error) {
      ElMessage.error('删除失败')
      console.error('删除体重记录错误:', error)
    }
  }).catch(() => {
    ElMessage.info('已取消删除')
  })
}


// 转换为 GMT+8 时间
const offset = 8 * 60; // +8 时区，单位为分钟

function formatDate(date) {
  const yyyy = date.getUTCFullYear();
  const MM = String(date.getUTCMonth() + 1).padStart(2, '0'); // 月份从0开始
  const dd = String(date.getUTCDate()).padStart(2, '0');
  const hh = String(date.getUTCHours()).padStart(2, '0');
  const mm = String(date.getUTCMinutes()).padStart(2, '0');
  const ss = String(date.getUTCSeconds()).padStart(2, '0');
  return `${yyyy}-${MM}-${dd} ${hh}:${mm}:${ss}`;
}

const saveRecord = async () => {
  if (!isEdit.value && !weightForm.patientId) {
    ElMessage.error('请选择患者')
    return
  }
  if (weightForm.weight === null || weightForm.weight === undefined || weightForm.weight === '') {
    ElMessage.error('请填写体重信息')
    return
  }
  if (isEdit.value && !weightForm.id) {
    ElMessage.error('缺少记录ID，无法修改')
    return
  }
  
  try {
    const recordData = {
      userId: weightForm.patientId,
      weight: weightForm.weight,
      type: weightForm.type,
      createTime: formatDate(new Date(weightForm.createTime || Date.now()))
    }
    
    let response
    if (isEdit.value) {
      recordData.id = weightForm.id
      response = await patientAPI.updateWeightHistory(recordData)
    } else {
      response = await patientAPI.addWeightHistory(recordData)
    }
    
    if (response.code === 0) {
      ElMessage.success(isEdit.value ? '修改成功' : '新增成功')
      recordDialogVisible.value = false
      fetchWeightHistory()
      if (userWeightDialogVisible.value && selectedUserId.value) {
        fetchWeightHistory({ userId: selectedUserId.value, forDialog: true })
      }
    } else {
      ElMessage.error(response.msg || (isEdit.value ? '修改失败' : '新增失败'))
    }
  } catch (error) {
    ElMessage.error(isEdit.value ? '修改失败' : '新增失败')
    console.error('保存体重记录错误:', error)
  }
}

const refreshData = () => {
  fetchWeightHistory()
}

const handleSizeChange = (val) => {
  pageSize.value = val
  currentPage.value = 1
  fetchWeightHistory()
}

const handleCurrentChange = (val) => {
  currentPage.value = val
  fetchWeightHistory()
}

// 搜索处理函数
const handleSearch = () => {
  if (patientFilter.value || phoneFilter.value) {
    currentPage.value = 1 // 重置到第一页
    fetchWeightHistory() // 获取体重历史记录
  }
}

// 重置处理函数
const handleReset = () => {
  patientFilter.value = ''
  phoneFilter.value = ''
  dateRange.value = []
  currentPage.value = 1
  weightList.value = []
  total.value = 0
}

// 监听日期范围变化
watch(dateRange, () => {
  if (patientFilter.value || phoneFilter.value) {
    fetchWeightHistory()
  }
})

// 监听图表类型变化
watch(chartType, () => {
  // 图表类型改变时，图表会自动重新渲染
})

// 组件挂载时根据路由参数决定加载方式
onMounted(() => {
  const incomingName = Array.isArray(route.query?.patientName)
    ? route.query.patientName[0]
    : route.query?.patientName

  if (incomingName) {
    patientFilter.value = incomingName
    currentPage.value = 1
    fetchWeightHistory()
  } else {
    getWeightNewList()
  }
})
</script>

<style scoped>
.weight-page {
  padding: 20px;
}

.page-header {
  margin-bottom: 30px;
}

.page-header h1 {
  font-size: 28px;
  color: #1e293b;
  margin: 0 0 10px 0;
}

.page-header p {
  color: #64748b;
  margin: 0;
}

.data-overview {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.overview-card {
  background: white;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  gap: 16px;
}

.overview-icon {
  width: 50px;
  height: 50px;
  border-radius: 10px;
  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 20px;
}

.overview-content {
  flex: 1;
}

.overview-number {
  font-size: 24px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 4px;
}

.overview-label {
  color: #64748b;
  font-size: 14px;
}

.filter-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  background: white;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.filter-left {
  display: flex;
  gap: 16px;
}

.filter-right {
  display: flex;
  gap: 12px;
}

.chart-section {
  background: white;
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
}

.chart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.chart-header h3 {
  margin: 0;
  color: #1e293b;
}

.chart-controls {
  display: flex;
  gap: 12px;
  align-items: center;
}

.chart-container {
  height: 400px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
}

.weight-table {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px 0;
  margin-bottom: 20px;
}

.table-header h3 {
  margin: 0;
  color: #1e293b;
}

.pagination-wrapper {
  padding: 20px;
  display: flex;
  justify-content: center;
}

.weight-light {
  color: #f59e0b;
}

.weight-above-dry {
  color: #f56c6c;
}

.weight-below-dry {
  color: #67c23a;
}

.weight-normal {
  color: #10b981;
}

.weight-heavy {
  color: #ef4444;
}

.no-patient-tip {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 60px 20px;
  margin: 20px 0;
}

.tip-content {
  text-align: center;
  color: #64748b;
}

.tip-content h3 {
  margin: 16px 0 8px 0;
  color: #475569;
  font-size: 20px;
}

.tip-content p {
  margin: 0;
  font-size: 14px;
}

@media (max-width: 768px) {
  .filter-section {
    flex-direction: column;
    gap: 16px;
    align-items: stretch;
  }
  
  .filter-left {
    flex-direction: column;
  }
  
  .filter-right {
    justify-content: center;
  }
  
  .data-overview {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
